import { Component, Input, OnInit } from '@angular/core';
import { GamificationLeagueDto } from '../../shared/types/GamificationLeagueDto';
import { OeAppService } from '../../shared/oe-app.service';
import { TranslationService } from '../../shared/translation.service';

@Component({
  selector: 'lp2-initial-ticket',
  templateUrl: './initial-ticket.component.html',
  styleUrls: ['./initial-ticket.component.scss'],
})
export class InitialTicketComponent implements OnInit {
  @Input()
  leagues: GamificationLeagueDto[];

  gamificationS3Url = `//${this.oeApp.s3BucketHost()}/gamification`;

  language = 'en';

  constructor(
    private oeApp: OeAppService,
    private translationService: TranslationService
  ) {}

  ngOnInit() {
    this.language = this.translationService.getCurrentLanguage();
  }
}



// WEBPACK FOOTER //
// ./ts/app/progress/initial-ticket/initial-ticket.component.ts